<template>
  <v-dialog v-model="dialog" persistent max-width="800">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" outlined color="success" class="ml-3">
        Novo Acompanhamento
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="modal-header elevation-10">
        <v-row>
          <v-col>
            <slot name="title">Criação de novo acompanhamento</slot>
          </v-col>
          <v-col class="text-right">
            <v-icon @click="dialog = false" color="white"
              >mdi-window-close</v-icon
            >
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row class="text-center">
          <v-col>
            <h2>Selecione um tema para responder</h2>
            <v-divider></v-divider>
          </v-col>
        </v-row>

        <v-row class="text-center">
          <v-col>
            <v-select
              id="temas-select"
              v-model="temaId"
              item-text="tema.nome"
              item-value="tema.temaId"
              item-name="municipioTemaPontoId"
              :items="temas"
              label="Tema"
              placeholder="Tema"
              @change="getPontosNaoEvidenciados()"
            >
              <template slot="no-data"> Nenhum Tema retornado </template>
            </v-select>
          </v-col>
        </v-row>

        <v-row v-if="payload.pontosNaoEvidenciados > 0" class="text-center">
          <v-col
            >Ao criar um novo acompanhamento, serão descontados
            {{ payload.pontosNaoEvidenciados }} PONTOS de questões não
            evidenciadas? Confirma a operação?</v-col
          >
        </v-row>

        <v-row v-if="payload.perguntasRejeitadas === true" class="text-center">
          <v-col>
            <v-alert class="error">
              Existem questões com evidências rejeitadas. Envie novas evidências
              para aprovação.
            </v-alert>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="error" outlined text @click="dialog = false"
          >Fechar</v-btn
        >
        <v-btn color="info" outlined text @click="getNovoAcompanhamento()"
          >Confirmar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { attendanceAPI } from "@/modules/attendance";
import { cityThemePointAPI } from "@/modules/city";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "AppModalInsertAttendance",
  props: {
    dialog: { type: Boolean },
  },
  computed: {
    ...mapGetters(["loading", "user"]),
  },
  data() {
    return {
      payload: {},
      municipioId: this.$route.params.id,
      temaId: 0,
      temas: {},
    };
  },
  created() {
    this.getTemasFinalizados();
  },
  methods: {
    ...mapActions(["setLoading"]),
    getPontosNaoEvidenciados() {
      this.setLoading(true);

      attendanceAPI
        .getPontosNaoEvidenciadosTema(this.municipioId, this.temaId)
        .then((resp) => {
          this.payload = resp.data;
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter novo acompanhamento");
        });
    },
    getNovoAcompanhamento() {
      this.setLoading(true);

      attendanceAPI
        .getNovoTema(this.municipioId, this.temaId)
        .then((resp) => {
          this.payload = resp.data;
          if (resp.data.acompanhamentoId != 0) {
            this.$router.push(
              "/cidade/" +
                this.municipioId +
                "/acompanhamento/obter/" +
                resp.data.acompanhamentoId
            );
            this.setLoading(false);
          }
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter perguntas");
        });
    },
    getTemasFinalizados() {
      this.setLoading(true);

      cityThemePointAPI
        .getTemasFinalizados(this.municipioId)
        .then((resp) => {
          this.temas = resp.data;
          if (!this.user.grupo.verTodosEixos) {
            this.temas = this.temas.filter((item) =>
              this.user.permissoes.some(
                (per) => per.eixoId === item.tema.eixoId
              )
            );
          }

          this.setLoading(false);
        })
        .catch((resp) => {
          console.log("Erro ao obter temas: ", resp);
          this.setLoading(false);
          this.$notification.error("Erro ao obter temas");
        });
    },
  },
};
</script>
